import { RecomendacaoModel } from '../../../../../projects/core/src/lib/core/model/RecomendacaoModel';
import { ResponseModel } from '../../../../../projects/core/src/lib/core/model/ResponseModel';
import { ListaRecomendacoesPage } from 'src/pages/navigation/recomendacoes/lista-recomendacoes/lista-recomendacoes.page';
import { TratamentoGatewayService } from 'projects/core/src/lib/core/TratamentoGatewayService';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { ContratoProvider } from 'projects/core/src/lib/core/provider/ContratoProvider';
import { CarteiraRecomendadaProvider } from 'projects/core/src/lib/core/provider/CarteiraRecomendadaProvider';
import FormatHelper from 'projects/core/src/lib/core/FormatHelper';
import { AppStorage } from 'projects/core/src/lib/core/AppStorage';
import { AppSession } from 'projects/core/src/lib/core/AppSession';
import { AtivoModel } from 'projects/core/src/lib/core/model/AtivoModel';
import { RecomendacaoAtivoProvider } from 'projects/core/src/lib/core/provider/RecomendacaoAtivoProvider';

export class ListaRecomendacoesViewModel {
    carteiraRecomendadaProvider = new CarteiraRecomendadaProvider()
    webSocket: WebSocket = null
    tryReconnect = 0
    recomendacaoModel = new RecomendacaoModel()
    context: ListaRecomendacoesPage
    offset: number = 0
    LIMIT_LIST = 20
    contratoProvider = new ContratoProvider()
    RecomendacaoAtivoProvider = new RecomendacaoAtivoProvider()

    setContext(context: ListaRecomendacoesPage) {
        this.context = context
    }

    getContext(): ListaRecomendacoesPage {
        return this.context
    }

    addOffset() {
        this.offset += this.LIMIT_LIST
    }

    resetOffset() {
        this.offset = 0
    }

    async setPreferenciaUsuario(tipoAtivo) {
        return await AppStorage.set(AppSession.CHAVE_TIPO_ATIVO_SELECIONADO_RECOMENDACOES, tipoAtivo)
    }

    async getPreferenciaUsuario(): Promise<string> {
        return await AppStorage.get(AppSession.CHAVE_TIPO_ATIVO_SELECIONADO_RECOMENDACOES)
    }

    async buscaContratos() {
        const retorno = await this.contratoProvider.listaContratosPorUsuario()
        this.getContext().setListaContratos(retorno)
    }

    async getRecomedacoesCurtoPrazo(mercado: String, tipoRecomendacao: number) {
        const retorno = await this.getListaRecomendacoes(mercado, tipoRecomendacao)
        this.getContext().setListaRecomendacaoCurto(retorno)
    }

    async getRecomedacoesMedioPrazo(mercado: String, tipoRecomendacao: number) {
        const retorno = await this.getListaRecomendacoes(mercado, tipoRecomendacao)
        this.getContext().setListaRecomendacaoMedio(retorno)
    }

    async getRecomedacoesLongoPrazo(mercado: String, tipoRecomendacao: number) {
        const retorno = await this.getListaRecomendacoes(mercado, tipoRecomendacao)
        this.getContext().setListaRecomendacaoLongo(retorno)
    }

    async getRecomedacoesTodas(mercado: String) {
        const retorno = await this.getListaRecomendacoes(mercado, null)
        this.getContext().setListaRecomendacaoTodas(retorno)
    }

    async getRecomedacoesEncerradasTodas(tipoAtivo: String) {
        const todas = await this.getListaRecomendacoesEncerradas(tipoAtivo)
        this.getContext().setListaRecomendacaoEncerrados(todas)
    }


    async getListaRecomendacoes(mercado: String, tipoRecomendacao: number, filtro?: String) {
        let retorno = await this.recomendacaoModel.listaRecomendacoes(mercado, this.LIMIT_LIST, this.offset, filtro, tipoRecomendacao)
        try {
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                return retorno.data
            } else {
                throw new Error(ThrowError.MESSAGE_DEFAULT)
            }
        } catch (e) { }
    }

    async getListaRecomendacoesEncerradas(mercado: String, filtro?: String) {
        let retorno = await this.recomendacaoModel.listaRecomendacoes(mercado, this.LIMIT_LIST, this.offset, filtro, null, "encerradas")
        try {
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                return retorno.data
            } else {
                throw new Error(ThrowError.MESSAGE_DEFAULT)
            }
        } catch (e) { }
    }

    async initWebSocket(callback = null) {
        let self = this
        this.webSocket = await this.carteiraRecomendadaProvider.connectWebsocket()
        this.webSocket.onmessage = function (event) {
            self.handlerWebSocketMessage(event.data);
        }
        this.webSocket.onopen = function (evt) {
            console.log("onopen.");
            if (callback != null) callback()
        };
        this.webSocket.onclose = function (evt) {
            console.log("onclose.");
        };
        this.webSocket.onerror = function (evt) {
            console.log("Error!");
            if (self.tryReconnect < 3) {
                self.tryReconnect++;
                self.initWebSocket(callback)
            } else if (self.tryReconnect < 6) {
                setTimeout(() => {
                    self.tryReconnect++;
                    self.initWebSocket(callback)
                }, 5000)
            }
        };
    }

    handlerWebSocketMessage(data) {
        let split = data.split(":")
        let codigo = split[1]
        let cotacao = split[2]
        let variacao = split[3]

        let itemMap = this.getContext().listaAnaliseAtivosViewMap[codigo]

        if (!itemMap) return

        let ativo = this.getContext().listaAnaliseAtivosView[itemMap.lista][itemMap.indice]
        if (ativo !== undefined && ativo.cotacao != cotacao && ativo.variacao != variacao) {
            
            let contacaoWS = parseFloat(cotacao)
            let variacaoWS = parseFloat(variacao)

            if (!ativo.encerrada) {
                ativo.objetivos.forEach((item) => {
                    if (!item.atingido && ((contacaoWS >= item.valor && ativo.compra == 1) || (contacaoWS <= item.valor && ativo.compra == 0))) {
                        this.getContext().showToast(`${item.nome} atingido com sucesso!`)
                        item.atingido = true
                    }
                })
            }

            ativo.preco_atual = contacaoWS
            ativo.variacao = variacaoWS

            ativo.viewEstadoCor = true
            setTimeout(() => {
                ativo.viewEstadoCor = false
            }, 1500)

            ativo.cotacao_str = FormatHelper.formatCotacao(ativo.cotacao, ativo.prefixado, ativo.unidade)
            ativo.variacao_str = FormatHelper.formatVariacao(ativo.variacao)
        }
    }

    finishWebSocket() {
        if (this.webSocket != null) {
            this.webSocket.close()
        }
    }

    sendMessageSocketByTipoAtivo(ativos: Array<String>) {
        if (ativos.length <= 0) return
        this.webSocket.send("L:" + ativos.toString())
    }

    async salvaItemFavorito(item: AtivoModel, tipoAtivo: String) {
        await this.RecomendacaoAtivoProvider.salvaItemFavorito(item, tipoAtivo)
    }
    
    getChaveSessaoPorTipoAtivo(tipoAtivo) {
        return this.RecomendacaoAtivoProvider.getChaveSessaoPorTipoAtivo(tipoAtivo)
    }
    
    async getListaFavoritos(tipoAtivo: String) {
        return await this.RecomendacaoAtivoProvider.getListaFavoritos(tipoAtivo)
    }

    async checkIsFavorite(tipoAtivo, idAtivo) {
        return await this.RecomendacaoAtivoProvider.checkIsFavorite(tipoAtivo, idAtivo)
    }
}